import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics'

// Firebase config from environment variables
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
}

let analytics

if (typeof window !== 'undefined') {
  try {
    if (!getApps().length) {
      initializeApp(firebaseConfig)
    }
    analytics = getAnalytics()
  } catch (error) {
    console.log('Firebase Analytics initialization error:', error)
  }
}

export const frbAnalytics = (event, params = {}) => {
  try {
    logEvent(analytics, event, params)
  } catch (error) {
    console.log('Log event error:', error)
  }
}

export const frbSetUserProperties = (params = {}) => {
  try {
    setUserProperties(analytics, params)
  } catch (error) {
    console.log('Set user properties error:', error)
  }
}
